import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { RefitSingleLanding } from './types';

export function useRefitSingleLanding(): Page<RefitSingleLanding> {
  return useCurrentPage<Page<RefitSingleLanding>>();
}
